<template>
    <div>
        <pagamentos
            :pagamentos="pagamentosFiltrados"
            :showFornecedor="true"
            v-show="mostrarPagamentos"
            @atualizar-listagem="obterPagamentos()"
        >
            <template slot="controles">
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (DE)</label>
                            </strong>
                            <date-picker
                                ref="dp01"
                                v-model="dataInicial"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data inicial"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (ATÉ)</label>
                            </strong>
                            <date-picker
                                ref="dp02"
                                v-model="dataFinal"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data final"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Status</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="statusPagamentosSelect"
                                v-model="statusPagamentos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Classificação</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="classificacaoPagamentosSelect"
                                v-model="classificacaoPagamentos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <template slot="acoes" slot-scope="data">
                <span class="text-primary">
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharPagamento(data.pagamentoId)"
                    ></i>
                </span>
            </template>
        </pagamentos>
        <router-view></router-view>
    </div>
</template>

<script>
import Pagamentos from './Pagamentos'

export default {
    props: {
        dataServicos: {
            type: Object
        },

        rotaListagem: {
            type: String
        },

        rotaDetalhar: {
            type: String
        }
    },

    data() {
        return {
            pagamentos: [],
            pagamentosFiltrados: [],
            statusPagamentos: -1,
            statusPagamentosSelect: [
                { text: 'TODOS', value: -1 },
                { text: 'CRIADO', value: 0 },
                { text: 'EM ANÁLISE', value: 1 },
                { text: 'EM PROCESSAMENTO PELO SETOR FINANCEIRO', value: 2 },
                { text: 'REPROVADO', value: 3 },
                { text: 'REPROVADO PELO SETOR FINANCEIRO', value: 4 },
                { text: 'CONCLUÍDO', value: 5 }
            ],
            classificacaoPagamentos: 0,
            classificacaoPagamentosSelect: [
                { text: 'TODOS', value: 0 },
                { text: 'ESPECIAIS', value: 1 },
                { text: 'PRIORITÁRIOS', value: 2 }
            ],
            dataInicial: null,
            dataFinal: null,
            setDataInicial: false,
            setDataFinal: false
        }
    },

    methods: {
        obterPagamentos() {
            this.$store.dispatch('addRequest')
            let filtroDto = {
                status: this.statusPagamentos,
                classificacao: this.classificacaoPagamentos,
                dataInicial: this.dataInicial
                    ? this.$moment(this.dataInicial, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : '',
                dataFinal: this.dataFinal
                    ? this.$moment(this.dataFinal, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : ''
            }
            this.dataServicos.obterTodos(filtroDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.pagamentos = response.data
                        this.pagamentosFiltrados = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter pagamentos',
                            'ERROR',
                            this.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharPagamento(id) {
            this.$router.push({
                name: this.rotaDetalhar,
                params: {
                    pagamentoId: id
                }
            })
        }
    },

    created() {
        let dataAtual = new Date()
        this.dataInicial = this.$moment(dataAtual)
            .startOf('month')
            .format('DD/MM/YYYY')
        this.dataFinal = this.$moment(dataAtual)
            .endOf('month')
            .format('DD/MM/YYYY')
    },

    computed: {
        mostrarPagamentos() {
            return this.$route.name === this.rotaListagem
        }
    },

    watch: {
        statusPagamentos() {
            this.obterPagamentos()
        },

        classificacaoPagamentos() {
            this.obterPagamentos()
        },

        dataInicial() {
            if (this.dataInicial) {
                this.$refs.dp02.dp.minDate(this.dataInicial)
            } else {
                this.$refs.dp02.dp.minDate(false)
            }
            if (!this.setDataInicial) {
                this.setDataInicial = true
            }
            if (this.setDataInicial & this.setDataFinal) {
                this.obterPagamentos()
            }
        },

        dataFinal() {
            if (this.dataFinal) {
                this.$refs.dp01.dp.maxDate(this.dataFinal)
            } else {
                this.$refs.dp01.dp.maxDate(false)
            }
            if (!this.setDataFinal) {
                this.setDataFinal = true
            }
            if (this.setDataInicial & this.setDataFinal) {
                this.obterPagamentos()
            }
        }
    },

    components: {
        Pagamentos
    }
}
</script>
